const aggregator = require("./aggregator");
const auctioneer = require("./auctioneer");
const fixedTermTeller = require("./fixed-term-teller");
const fixedExpiryTeller = require("./fixed-expiry-teller");
const teller = require("./teller");
const markets = require("./markets");
const tokens = require("./tokens");

const Methods = {
  ...aggregator,
  ...auctioneer,
  ...fixedTermTeller,
  ...fixedExpiryTeller,
  ...teller,
  ...markets,
  ...tokens,
};

module.exports = { Methods };
